import "../css/home.css";
import { useNavigate } from "react-router-dom";
export default function App() {
  const nav = useNavigate();
  return (
    <>
      {/* NAVBAR */}
      <header className="navbar">
        <h1 className="logo">MenuLinker</h1>
        <nav>
          <a onClick={() => {nav("/signin")}}>Sign in</a>
          <a href="#features">Features</a>
          <a href="#pricing" className="cta">
            Get Started
          </a>
        </nav>
      </header>

      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-text fade-up">
          <h2>Create Beautiful Digital Menus in Minutes</h2>
          <p>
            Design menus, generate QR codes, edit items, and track analytics —
            all in one simple dashboard.
          </p>
          <a href="#pricing"><button className="hero-btn">Start Now</button></a>
        </div>

        <div className="hero-images">
          <img
            src="https://i.ibb.co/tp04fZMX/dash.png"
            alt="Dashboard Preview"
            className="img-dashboard float-up"
          />

          <img
            src="https://i.ibb.co/ZRg13rzj/localhost-3000-Pyzuj9-XMl-Jn-FLq2-Yo-Fe-U-i-Phone-XR.png"
            alt="Menu Preview"
            className="img-mobile float-up-delay"
          />
        </div>
      </section>

      {/* FEATURES */}
      <section className="features" id="features">
        <h2 className="section-title fade-up">Powerful Features</h2>

        <div className="features-grid">
          <div className="feature fade-up">
            <h3>📱 QR Code Menus</h3>
            <p>Instantly generate QR codes linked to your live digital menu.</p>
          </div>

          <div className="feature fade-up">
            <h3>🧾 Menu Editor</h3>
            <p>Easily manage items, prices, categories, and photos.</p>
          </div>

          <div className="feature fade-up">
            <h3>📊 Analytics</h3>
            <p>Track menu views, customer engagement, and performance.</p>
          </div>

          <div className="feature fade-up">
            <h3>🎨 Templates</h3>
            <p>Choose from beautiful menu styles tailored to your brand.</p>
          </div>
        </div>
      </section>

      {/* DEMO */}
      <section className="demo" id="demo">
        <h2 className="section-title fade-up">Live Preview</h2>
        <p className="section-subtext fade-up">
          A quick look at what your customers will see
        </p>

        <div className="demo-images">
          <img
            src="https://i.ibb.co/N6CsQqBQ/editor.png"
            className="demo-dash fade-up"
            alt="Dashboard Demo"
          />
          <img
            src="https://i.ibb.co/3ygFRxf8/localhost-3000-Pyzuj9-XMl-Jn-FLq2-Yo-Fe-U-i-Phone-XR-1.png"
            className="demo-menu fade-up-delay"
            alt="Menu Demo"
          />
        </div>
      </section>

     {/* PRICING SECTION */}
<section className="pricing" id="pricing">
  <h2 className="section-title fade-up">Simple, Transparent Pricing</h2>
  <p className="section-subtext fade-up">
    No contracts. No hidden fees. Cancel any time.
  </p>

  <div className="pricing-grid">
    {/* BASIC PLAN */}
    <div className="price-card fade-up">
      <h3>Basic</h3>
      <p className="price">$5<span>/mo</span></p>
      <ul>
        <li>✓ Unlimmited Online Menus</li>
        <li>✓ QR Code Generator</li>
        <li>✓ Menu Editor</li>
        <li>✓ 1 Template Style</li>
        <li>✓ Basic Analytics</li>
      </ul>
      <button onClick={() => nav("/signup")} className="price-btn">Choose Basic</button>
    </div>

    {/* PRO PLAN */}
      <div className="price-card pro fade-up-delay">
        <h3>Pro</h3>
        <p className="price">$10<span>/mo</span></p>
        <ul>
          <li>✓ Everything in Basic</li>
          <li>✓ 6 Template Styles (more to be added)</li>
          <li>✓ Add item images</li>
          <li>✓ Add header image</li>
          <li>✓ Priority Support</li>
        </ul>
        <button onClick={() => nav("/signup")} className="price-btn pro-btn">Choose Pro</button>
      </div>
    </div>
  </section>
      {/* FOOTER */}
      <footer>© 2025 Aware LLC. All rights reserved.</footer>
    </>
  );
}
